import { render, staticRenderFns } from "./Page01SubNew.vue?vue&type=template&id=a6cf42aa&scoped=true&"
import script from "./Page01SubNew.vue?vue&type=script&lang=js&"
export * from "./Page01SubNew.vue?vue&type=script&lang=js&"
import style0 from "./Page01SubNew.vue?vue&type=style&index=0&id=a6cf42aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cf42aa",
  null
  
)

export default component.exports
import {QCard,QCardSection,QCircularProgress,QTooltip,QChip,QDialog,QBar,QSpace,QBtn,QMarkupTable,QInnerLoading,QSpinnerGears,QTable,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QCircularProgress,QTooltip,QChip,QDialog,QBar,QSpace,QBtn,QMarkupTable,QInnerLoading,QSpinnerGears,QTable}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
